import React, { useEffect, useMemo, useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";
import { dataListProduct } from "./DefineData";
import { useDispatch, useSelector } from "react-redux";
import { getDataAwardListMiniGame } from "../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../Redux/selector";
import _ from "lodash";
import iconSuperPrize from "../../../../assets/images/Mini-Game/super-prize-icon.png";
import prizeContainerBgThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/prize-container-thadinyut-theme.png";
import prizeContainerNewYear from "../../../../assets/images/Mini-Game/new-year-2025/prize-container.png";
import {
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
// import { IS_EVENT_THADINGYUT_2025_THEME } from "../../../../helper/const";

export default function ListProduct({
  itemProductActive,
  setItemProductActive,
}) {
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      dispatch(getDataAwardListMiniGame());
    }
  }, []);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  const dataSort = dataMiniGame.dataAwardListMini?.sort(
    (a, b) => Number(a.rank) - Number(b.rank)
  );

  const swiperRef = useRef(null);
  const postionItemMenuActive = useMemo(() => {
    let postionItemActive = 0;

    dataListProduct.forEach((item, index) => {
      if (item.id === itemProductActive) {
        postionItemActive = index;
      }
    });

    return postionItemActive;
  }, [itemProductActive]);

  const isMobileMd = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
  const isMobileSm = useMediaQuery(`(max-width: ${mediaQueryPoint.sm}px)`);

  return (
    <>
      <Container>
        <Swiper
          ref={swiperRef}
          slidesPerView={isMobileSm ? 2.5 : isMobileMd ? 3.25 : 4.7} // Hiển thị total slide mỗi lần
          spaceBetween={6} // Khoảng cách giữa các slide
          speed={500} // Tốc độ chuyển slide
          freeMode={true} // Cho phép trượt tự do theo lực vuốt
          freeModeMomentum={true} // Đà vuốt, giúp cảm giác mượt mà
          pagination={{ clickable: false }} // Chấm điều hướng
          //   onSlideChange={handleSlideChange}
          initialSlide={postionItemMenuActive}
        >
          {dataSort?.map((item) => {
            return (
              <SwiperSlide
                key={item.id}
                onClick={() => setItemProductActive(item.id)}
                className={`prize-container ${
                  IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
                } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""} ${
                  +itemProductActive === +item.id
                    ? "prize-container-active"
                    : ""
                }`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className={`icon-prize`}
                />
                {+item.is_super_prize === 1 ? (
                  <img
                    src={iconSuperPrize}
                    alt=''
                    className='icon-super-prize'
                  />
                ) : null}
                {IS_EVENT_THADINGYUT_2025_THEME ? (
                  <TitleWrapper>
                    <div className='title-prize'>{item.name}</div>
                  </TitleWrapper>
                ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
                  <TitleWrapper className='new-year-25-theme'>
                    <div className='title-prize'>{item.name}</div>
                  </TitleWrapper>
                ) : (
                  <div className='title-prize'>{item.name}</div>
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Container>
    </>
  );
}

const TitleWrapper = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  transform: translateY(-12%);
  display: flex;
  align-items: center;

  .title-prize {
    position: unset !important;
    transform: unset !important;
    font-style: normal !important;
    width: 76% !important;
    margin: 0 auto !important;
    font-size: 13px !important;
    filter: none !important;
    color: white !important;

    @media (max-width: 1080px) and (min-width: 992px) {
      font-size: 11px !important;
    }

    @media (max-width: 435px) {
      font-size: 11px !important;
    }
  }

  &.new-year-25-theme {
    transform: translateY(-12%);
    .title-prize {
      filter: none !important;
    }
  }
`;

const Container = styled.div`
  padding-left: 18px;
  margin-bottom: 20px;

  .icon-super-prize {
    margin-left: 4px;
    margin-top: 4px;
    position: relative;
    z-index: 2;
  }

  .icon-prize {
    position: absolute;
    top: 15px;
    height: 120px;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 5px;
    max-width: 90%;
  }

  .prize-container {
    position: relative;
    z-index: 1;
    height: 200px;
    cursor: pointer;
    border-radius: 12px;
    background: linear-gradient(
      180deg,
      rgba(149, 73, 17, 0.3) 0%,
      #bd601e 100%
    );
    opacity: 0.6;

    &.thadingyut-theme {
      background: url(${prizeContainerBgThadingyut});
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      border: none;
    }

    &.new-year-25-theme {
      background: url(${prizeContainerNewYear});
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      border: none;

      @media (max-width: 576px) {
        height: 180px !important;

        .icon-prize {
          height: 100px;
        }
      }
    }
  }

  .prize-container-active {
    opacity: 1;
    background: linear-gradient(0deg, #ff7a00 0%, #ffb639 100%);
    border: 4px solid rgba(255, 255, 255, 0.8);

    &.thadingyut-theme {
      border: none;
    }
  }

  .prize-mmk {
    height: auto;
    /* min-width: 150px; */
    max-width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .title-prize {
    position: absolute;
    bottom: 14px;
    z-index: 3;
    font-size: 17px;
    color: #ffebbd;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    text-align: center;
    font-weight: bold;
    font-style: italic;
    filter: drop-shadow(1px 0 0 #f27a25) drop-shadow(-1px 0 0 #f27a25)
      drop-shadow(0 1px 0 #f27a25) drop-shadow(0 -1px 0 #f27a25) !important;

    @media (max-width: 576px) {
      font-size: 14px;
    }

    @media (max-width: 435px) {
      font-size: 12px;
    }
  }

  .prize-container-active {
    /* border: 2px solid white; */
  }

  .prize-container-active:hover {
    opacity: 1;
    background: linear-gradient(0deg, #ff7a00 0%, #ffb639 100%);

    &.thadingyut-theme {
      background: url(${prizeContainerBgThadingyut}) !important;
      background-size: 100% 100% !important;
      background-repeat: no-repeat !important;
      background-position: center center !important;
    }

    &.new-year-25-theme {
      background: url(${prizeContainerNewYear}) !important;
      background-size: 100% 100% !important;
      background-repeat: no-repeat !important;
      background-position: center center !important;
    }
  }

  @media (min-width: 992px) {
    .prize-container:hover {
      opacity: 0.9;
    }

    .prize-container-active:hover {
      opacity: 1;
      background: linear-gradient(0deg, #ff7a00 0%, #ffb639 100%);
    }
  }

  @media (max-width: 576px) {
    padding-left: 10px;

    .icon-prize {
      height: 60px;
    }

    .prize-container {
      height: 105px;
    }

    .prize-container.thadingyut-theme {
      height: 175px;

      .icon-prize {
        height: 80px;
      }
    }
    .title-prize {
      bottom: 5px;
    }
  }

  @media (min-width: 1400px) {
    padding-left: 40px;
  }
`;
